import { CloudAgentClient } from "client/customer/agent";
import { CloudCompletionClient } from "client/customer/completion";
import { CloudContainerClient } from "client/customer/container";
import { CloudContentGenerationClient } from "client/customer/content_generation";
import { CloudDatasetClient } from "client/customer/dataset";
import { CloudViewClient } from "client/customer/view";
import { CloudMetaClient } from "client/customer/meta";
import { CloudMetadataClient } from "client/customer/metadata";
import { CloudProjectClient } from "client/customer/project";
import { CloudAnalyticsClient } from "client/customer/analytics";
import { CloudSchemaMonitorClient } from "client/customer/schema";
import { isAWSAccount } from "types/account";
import { getAgentEndpoint, getClient, getOpenShellEndpoint } from "../aible/account/without_factory";
import { CloudAgentExecutionClient } from "./agent_execution";
import { OpenShellClient } from "./openshell";
export class CustomerClientFactory {
    base;
    config;
    account;
    accountClientWithoutFactory;
    datasetClient;
    viewClient;
    projectClient;
    metaClient;
    completionClient;
    contentGenerationClient;
    metadataClient;
    analyticsClient;
    schemaMonitorClient;
    agentClient;
    containerClient;
    constructor(base, config, account, accountClientWithoutFactory) {
        this.base = base;
        this.config = config;
        this.account = account;
        this.accountClientWithoutFactory = accountClientWithoutFactory;
        this.datasetClient = new CloudDatasetClient(this.base, this.account);
        this.viewClient = new CloudViewClient(this.base);
        this.projectClient = new CloudProjectClient(this.base, this.config, this.account, this.accountClientWithoutFactory);
        this.metaClient = new CloudMetaClient(this.base, this.account);
        this.completionClient = new CloudCompletionClient(this.base);
        this.contentGenerationClient = new CloudContentGenerationClient(this.base);
        this.metadataClient = new CloudMetadataClient(this.base);
        this.analyticsClient = new CloudAnalyticsClient(this.base);
        this.schemaMonitorClient = new CloudSchemaMonitorClient(this.base);
        this.agentClient = new CloudAgentClient(this.base);
        this.containerClient = new CloudContainerClient(this.base);
    }
    getDatasetClient() {
        return this.datasetClient;
    }
    getViewClient() {
        return this.viewClient;
    }
    getProjectClient() {
        return this.projectClient;
    }
    getMetaClient() {
        return this.metaClient;
    }
    getCompletionClient() {
        return this.completionClient;
    }
    getContentGenerationClient() {
        return this.contentGenerationClient;
    }
    getMetadataClient() {
        return this.metadataClient;
    }
    getAnalyticsClient() {
        return this.analyticsClient;
    }
    getSchemaMonitorClient() {
        return this.schemaMonitorClient;
    }
    getAgentClient() {
        return this.agentClient;
    }
    getContainerClient() {
        return this.containerClient;
    }
}
function getHeaders(account) {
    if (isAWSAccount(account)) {
        return { credentials: "include" };
    }
    return undefined;
}
export class AgentClientFactory {
    agentExecutionClient;
    openShellClient;
    constructor(agentExecutionClient, openShellClient) {
        this.agentExecutionClient = agentExecutionClient;
        this.openShellClient = openShellClient;
    }
    getAgentExecutionClient() {
        return this.agentExecutionClient;
    }
    getOpenShellClient() {
        return this.openShellClient;
    }
    static create(account) {
        const headers = getHeaders(account);
        const agentExecutionClient = new CloudAgentExecutionClient(getClient(getAgentEndpoint(account), headers, account));
        const openShellClient = new OpenShellClient(getClient(getOpenShellEndpoint(account), headers, account));
        return new AgentClientFactory(agentExecutionClient, openShellClient);
    }
}
